/**
 * @file Functions for making http requests for overview
 * @author Max van Loosbroek
 */

import { IHttpResponse, IHttpService, IPromise, IRequestShortcutConfig } from 'angular'
import { URLS } from '../../../../common/utilities/constants/constants.module'
import { parseHttpError } from '../../../../common/utilities/errorHandling'
import { DetailedTaasOrder } from '../../../overview/types/types'
import { RetrievedResult } from '../../types/types'

export const getOrders = (
  $http: IHttpService,
  config: IRequestShortcutConfig
): IPromise<IHttpResponse<DetailedTaasOrder[]>> => {
  const url = URLS.admin.taasOrders
  return $http.get<DetailedTaasOrder[]>(url, config).catch(parseHttpError)
}

export const retrieveConceptsRequest = (
  $http: IHttpService,
  config: IRequestShortcutConfig
): IPromise<IHttpResponse<RetrievedResult>> => {
  const url = URLS.admin.retrieveConcepts
  return $http.post<RetrievedResult>(url, config).catch(parseHttpError)
}
